import React from "react";
import "../../../styles/component/common/stat-card.scss";
import LoadingSkeleton from "../loading-skeleton/loading-skeleton";

export type StatCardColor = 'default' | 'green' | 'blue' | 'orange' | 'red' | 'gray' | 'pink'|'brown'|'teal';

export interface StatCardData {
    key: string;
    label: string;
    value?: React.ReactNode;
    icon: React.ElementType;
    color?: StatCardColor;
    onClick?: () => void;
}

export interface StatCardProps {
    data: StatCardData[];
    size?: 'small' | 'medium' | 'large';
    loading?: boolean;
}

const StatCards: React.FC<StatCardProps> = ({data, size = 'small', loading}: StatCardProps) => {

    return (
        <section className={`pn-stats__grid ${size}`}>
            {
                data.map((item: StatCardData) => {
                    const {label, value, color = 'default', onClick} = item;
                    const Icon = item.icon;
                    return (
                        <LoadingSkeleton loading={loading} key={item.key}>
                            <div
                                key={item.key}
                                className={['pn-stat-card', size, `pn-stat-card__${color}`, onClick ? 'pn-stat-card__clickable' : ''].join(' ')}
                                onClick={onClick}
                                role={onClick ? 'button' : undefined}
                                tabIndex={onClick ? 0 : undefined}
                            >
                                <div className="pn-stat-card__icon" aria-hidden="true"><Icon/></div>
                                <div className="pn-stat-card__body">
                                    <span className="pn-stat-card__value">{value}</span>
                                    {/*<span className="pn-stat-card__value">{String(value).padStart(2, '0')}</span>*/}
                                    <span className="pn-stat-card__label">{label}</span>
                                </div>
                            </div>
                        </LoadingSkeleton>

                    )
                })
            }
        </section>

    )
};

export default StatCards;
